import { playwrightUniDriver } from '@wix/unidriver-playwright';
import { Locator, Page } from 'playwright';
import { UniDriver } from '@wix/unidriver-core';
import { BaseUniDriver } from '../base-driver';

interface DriverFactoryOptions {
  dataHook: string;
}

export function playwrightUniTestkitFactoryCreator<T extends BaseUniDriver>(
  driverFactory: (
    base: UniDriver,
    body: UniDriver,
    options: DriverFactoryOptions,
  ) => T,
) {
  return async (arg: { dataHook: string; page: Page; wrapper?: Locator }) => {
    const { dataHook, page, wrapper } = arg;
    const selector = `[data-hook='${dataHook}']`;

    const baseLocator = wrapper || page;

    const base = playwrightUniDriver(baseLocator.locator(selector));
    const body = playwrightUniDriver(page.locator('body'));

    return driverFactory(base, body, { dataHook });
  };
}
